export default __webpack_public_path__ + "static/media/Trust.80f6fee3.pdf";